import { AbstractControlOptions, ValidatorFn, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { IAPIResponse } from "./response.model";

export interface IFormField {
    fieldName : string;
    displayName : string;
    defaultValue : string | null | number; // TBD 
    labelName : string
    placeholder ?: string;
    validators : ValidatorFn | ValidatorFn[] | AbstractControlOptions | null | undefined;
    fieldType : FieldEnum;
    fieldSubType : SubFieldEnum;
    size : string;
    UIVisible : boolean;
    selectFields ?: ISelectField;
    updateOn ?: "blur" | "submit";
    disabled ?: boolean;
    required ?: boolean;
    hasDescription ?: boolean;
    hasCondition?:boolean;
    isAutoComplete?:boolean;
    condition?:string;
}

export interface ISelectField {
    apiAsync$ : Observable<IAPIResponse<any>>,
    bindLabel : string,
    bindValue : string,
    dataFields : Array<any>
}

export enum FieldEnum {
    INPUT = "input",
    SELECT = "select",
    TEXTAREA = "textarea",
    CHECKBOX = "checkobox",
    RADIO = "radio"
}

export enum SubFieldEnum {
    TEXT = "text",
    DATE = "date"
}